import { BoxGeometry, Mesh, MeshLambertMaterial } from "three";

let _ctx;
const markers = [];

const material = new MeshLambertMaterial({
    color: 0xff88ff,
    transparent: true,
    opacity: 0.3
});

const Markers = {


    init: function (ctx) {
        _ctx = ctx;

    },

    create: function () {

        const marker = new Mesh(new BoxGeometry(0.05, 0.05, 0.05), material);

        _ctx.scene.add(marker);
        markers.push(marker);

        return markers.length - 1;

    },
    destroy: function (id)
    {
        const removed = markers.splice(id, 1);
        if (removed.length)
        {
            _ctx.remove.add(removed[0]);
        }
    },
    update: function (id, pos) {
        markers[id].position.copy(pos);
    },

};

window.markers = markers;

export default Markers;



// WEBPACK FOOTER //
// ./src/util/markers.js